import React from 'react';
import styled from 'styled-components';
import { Parallax, Background } from 'react-parallax';

import ProductContentRows from './product-content-rows';
import RelatedProducts from './related-products';
import ProductTiles from './product-tiles';
import ProductReviews from './product-reviews/index';

import ProductWave from './product-wave';
import VideoPlayer from '../elements/video-player';

import CollectionBlogFeed from '../collection-components/collection-blog-feed';
import HomeSplitSection from '../page-components/home/home-split-section';

import { media } from '../helpers';

const ProductAboutSectionContainer = styled.div`
    position: relative;
    top: -10vh;
    margin-bottom: -10vh;
    ${media.medium`top: -25vh;margin-bottom: -25vh;`}
    ${media.large`top: -30vh;margin-bottom: -30vh;`}

    .video-outer-container {
        top: -15vh;
        margin-bottom: -15vh;
        position: relative;
    }
`;

const ProductAboutSection = ({ assets, reviews, product }) => {
    const { pdp_acf } = assets || {};
    // console.log(pdp_acf);
    const {
        isProductColormatchChart,
        productSplitSectionSettings,
        productBlogFeed,
        productVideoSettings,
    } = pdp_acf || {};

    const isColorChart =
        isProductColormatchChart === undefined ||
        isProductColormatchChart === 'no';
    return (
        <>
            <ProductAboutSectionContainer>
                {isColorChart ? (
                    <>
                        <ProductContentRows pdp_acf={pdp_acf} />
                        <ProductReviews
                            reviews={reviews}
                            handle={product.handle}
                        />
                        <RelatedProducts
                            handle={
                                pdp_acf
                                    ? pdp_acf.relatedProductsCollectionHandle
                                    : 'all'
                            }
                        />
                        {pdp_acf && (
                            <ProductTiles tiles={pdp_acf.productContentTiles} />
                        )}
                    </>
                ) : (
                    <>
                        <ProductWave pdp_acf={pdp_acf} />
                        {productVideoSettings && (
                            <div className="video-outer-container">
                                <VideoPlayer content={productVideoSettings} />
                            </div>
                        )}
                        {productSplitSectionSettings && (
                            <HomeSplitSection
                                content={productSplitSectionSettings}
                            />
                        )}
                        {productBlogFeed && (
                            <CollectionBlogFeed
                                title={productBlogFeed.sectionTitle}
                                handle={productBlogFeed.blogCategoryHandle}
                            />
                        )}
                    </>
                )}
            </ProductAboutSectionContainer>
        </>
    );
};

export default ProductAboutSection;
